import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { FC, useEffect } from "react";
import { Form, FormikValues, useFormikContext } from "formik";

import MemberDetails from "./MemberDetails/MemberDetails";
import OtherTrainings from "./OtherTrainings/OtherTrainings";
import ProgressSteps from "../../../common/ProgressSteps/ProgressSteps";
import TermsOfAppointment from "./TermsOfAppointment/TermsOfAppointment";
import TermsOfResignation from "./TermsOfResignation/TermsOfResignation";
import GoodClinicalPractices from "./GoodClinicalPractices/GoodClinicalPractices";
import QualificationRegistration from "./QualificationRegistration/QualificationRegistration";
import CreatePageFormFooter from "../../../common/Form/CreatePageFormFooter/CreatePageFormFooter";
import { IProps } from "../../../../types/EC/ec";
import { useParams } from "react-router-dom";
import { useGetEcmUserDetailLazyQuery } from "../../../../generated/graphql";
import { createMemberInitData } from "../utils";
import moment from "moment";

const CreateECMemberForm: FC<IProps> = (props) => {
  const { steps, setSteps, stepsInfo } = props;
  const { id } = useParams() as any;
  const { setValues } = useFormikContext<FormikValues>();
  const [getUserById] = useGetEcmUserDetailLazyQuery();
  useEffect(() => {
    if (id) {
      const getData = async () => {
        const res = await getUserById({
          variables: { id },
        });
        const newFormValues = {
          ...createMemberInitData,
          ...res.data?.getUserById,
          dateOfAppointment: moment(
            res.data?.getUserById.dateOfAppointment
          ).format("yyyy-MM-DD"),
          dateOFTenureCompletion: moment(
            res.data?.getUserById.dateOFTenureCompletion
          ).format("yyyy-MM-DD"),
          dateOfCertification: moment(
            res.data?.getUserById.dateOfCertification
          ).format("yyyy-MM-DD"),
          dateOfResignation: moment(
            res.data?.getUserById.dateOfResignation
          ).format("yyyy-MM-DD"),
          nextGCPCertificateDueOn: moment(
            res.data?.getUserById.nextGCPCertificateDueOn
          ).format("yyyy-MM-DD"),
          validUpto: moment(res.data?.getUserById.validUpto).format(
            "yyyy-MM-DD"
          ),
          GCPCertificate1: res.data?.getUserById?.GCPCertificate[0],
          GCPCertificate2: res.data?.getUserById?.GCPCertificate[1],
          trainings: res.data?.getUserById?.trainings.map((t) => ({
            date: moment(t.date).format("yyyy-MM-DD"),
            url: t.url,
            name: t.name,
          })),
        };
        setValues({ ...newFormValues });
      };
      getData();
    }
  }, [getUserById, setValues, id]);

  return (
    <Form>
      <Container maxWidth={false}>
        <Card>
          <CardContent className="pd-x-32 pd-t-32 pd-b-20">
            <Box className="mg-b-40">
              <Typography className="mg-b-10" variant="h2" component="h2">
                Member Creation
              </Typography>
              <ProgressSteps stepsInfo={stepsInfo} currentStep={steps} />
            </Box>
            <Grid container className="justify-content-center">
              <Grid item xs={12} md={10} lg={10}>
                {steps === 0 && <MemberDetails />}
                {steps === 1 && <TermsOfAppointment />}
                {steps === 2 && <QualificationRegistration />}
                {steps === 3 && <GoodClinicalPractices />}
                {steps === 4 && <OtherTrainings />}
                {steps === 5 && <TermsOfResignation />}
                <CreatePageFormFooter
                  setSteps={setSteps}
                  steps={steps}
                  stepsInfo={stepsInfo}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Form>
  );
};

export default CreateECMemberForm;
